<script>
  import Modal from "../../components/Modal.svelte";

  let { profile } = $props();

  let showEngagementReasonModal = $state(false);

  function openEngagementReasonModal() {
    showEngagementReasonModal = true;
  }
</script>

<div class="bg-white shadow rounded-lg p-3 sm:p-6">
  <div class="flex justify-between items-start">
    <div>
      <p class="text-xs sm:text-sm font-medium text-gray-500 flex items-center">
        Engagement Score
      </p>
      <h3 class="text-xl sm:text-3xl font-bold text-gray-900 mt-1">
        {profile.engagement_score ? `${profile.engagement_score}%` : "-"}
      </h3>
    </div>
    <div
      class="bg-yellow-100 p-1.5 sm:p-2 rounded-md cursor-pointer hover:bg-yellow-200 transition-colors duration-200"
      onclick={openEngagementReasonModal}
      title="View engagement details"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4 sm:h-6 sm:w-6 text-yellow-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13 10V3L4 14h7v7l9-11h-7z"
        />
      </svg>
    </div>
  </div>
  <div class="mt-1 sm:mt-2 flex items-center justify-between">
    <div></div>

    {#if profile.engagement_score && profile.engagement_reason && profile.engagement_reason.length > 0}
      <button
        onclick={openEngagementReasonModal}
        class="cursor-pointer text-xs text-indigo-600 hover:text-indigo-800 font-medium flex items-center"
      >
        Learn more
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-3 w-3 ml-1"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    {/if}
  </div>
</div>

<Modal
  open={showEngagementReasonModal}
  title="Engagement Score Explained"
  size="lg"
  closed={() => (showEngagementReasonModal = false)}
>
  {#snippet content()}
    <div class="space-y-6">
      <div class="flex items-center">
        <div
          class="flex-shrink-0 bg-gradient-to-r from-yellow-400 to-yellow-600 p-3 rounded-full"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-8 w-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 10V3L4 14h7v7l9-11h-7z"
            />
          </svg>
        </div>
        <div class="ml-5">
          <h3 class="text-xl font-bold text-gray-900">
            Current Score: <span class="text-yellow-600"
              >{profile.engagement_score}%</span
            >
          </h3>
          <div class="mt-2 flex items-center">
            <div class="w-full max-w-xs bg-gray-200 rounded-full h-2.5">
              <div
                class="bg-gradient-to-r from-yellow-400 to-yellow-600 h-2.5 rounded-full"
                style="width: {profile.engagement_score}%"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-md">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg
              class="h-5 w-5 text-yellow-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-yellow-700">
              Engagement score is calculated based on likes, comments, saves,
              and shares relative to follower count.
            </p>
          </div>
        </div>
      </div>

      <div class="prose prose-indigo max-w-none">
        <h4 class="text-lg font-semibold text-gray-900">Analysis</h4>
        <p class="text-gray-700">
          {profile.engagement_reason || "No detailed analysis available yet."}
        </p>
      </div>
    </div>
  {/snippet}
</Modal>
